(function ($, app, _) {
	"use strict";

	app.m49 = function () {
		var $mod = $(".m49"),
			$partModule = $mod.find('.part-module'),
			$partChanger = $mod.find('.part-changer'),
			onTabChangeListeners = [];

		$partModule.each(function () {
			initializeOnModule($(this));
		});

		//hide all tabs first
		$mod.find(".ttab-content").hide();
		//show the first tab content
		$mod.find(".part-module").show();

		$partChanger.change(function () {
			var val = $(this).val();
			$mod.find(".ttab-content").hide();
			$mod.find("#ttab-" + val).show();

			onTabChangeListeners.forEach(function (listener) {
				listener(val)
			})
		});

		function initializeOnModule($module) {
			var $partHolderPanel = $module.find(".part-holder-panel"),
				$partImagesHolder = $partHolderPanel.find(".part-images-points-holder"),
				$subPartImagesHolder = $partHolderPanel.find(".sub-part-images-points-holder"),
				$mainPanel = $partHolderPanel.find(".main-panel.main-panel-with-points"),
				$listPanel = $partHolderPanel.find('.list-panel-container'),
				$mainImage = $mainPanel.find("img.main-image"),
				$pointHolder = $mainPanel.find(".part-points-holder"),
				$subPartPointHolder = $module.find(".sub-part-points-holder"),
				$closeDetailProduct = $partHolderPanel.find('.close-detail-product'),
				$tabLink1 = $module.find(".tp1-tab-link"),
				$tabLink2 = $module.find(".tp2-tab-link"),
				$tabsButtonsListItems = $module.find('.tabs-buttons ul li'),
				mainImageWidth = $mainImage[0].naturalWidth,
				mainImageHeight = $mainImage[0].naturalHeight,
				tabId = $module.attr('data-tab'),
				activeTab = 1,
				activePartId = undefined,
				activeSubPartId = undefined,
				currentLevelCounter = undefined;

			$tabsButtonsListItems.hide();

			$tabLink1.click(showImageViewTab);

			function showImageViewTab()
			{
				if (! activePartId) {
					return;
				}
				$tabLink1.addClass("active");
				$tabLink2.removeClass("active");

				findImageDetailList(activePartId, currentLevelCounter).hide();
				showLevel(currentLevelCounter)

				activeTab = 1

			}

			$tabLink2.click(function () {
				if (!activePartId) {
					return;
				}
				$tabLink2.addClass("active");
				$tabLink1.removeClass("active");
				var $imgDetail = $listPanel.find('.img-detail#p' + activePartId +'-img-detail');
				var $imgDetailList = findImageDetailList(activePartId, currentLevelCounter);
				$imgDetailList.show();
				$imgDetail.hide();
				activeTab = 2;

				hideAllSubPartPointHolders();
			});

			function findImageDetailList(activePartId, levelCounter) {
				return $listPanel.find('ul.img-detail[data-level-counter="' + (levelCounter ? levelCounter : activePartId) + '"]');
			}

			onTabChangeListeners.push(function (tab) {
				if (tabId != tab) {
					return
				}
				setImageHolderSize();
			})
			setImageHolderSize();

			function setImageHolderSize()
			{
				mainImageWidth = $mainImage[0].naturalWidth;
				mainImageHeight = $mainImage[0].naturalHeight;

				if ($mainPanel.outerWidth() < mainImageWidth) {
					mainImageHeight = $mainPanel.outerWidth() / mainImageWidth * mainImageHeight;
					mainImageWidth = $mainPanel.outerWidth();
				}

				$partImagesHolder
					.css("width", mainImageWidth)
					.css("height", mainImageHeight);
			}

			$pointHolder.addClass('loaded');
			$subPartPointHolder.addClass("loaded");
			$subPartPointHolder.find(".sub-part-points").hide();

			$pointHolder.find('.part-point').each(function () {
				var $point = $(this),
					id = $(this).attr('data-id'),
					partId = $(this).attr('data-part-id'),
					$text = $pointHolder.find('.part-point-text[data-id="' + id +'"]'),
					$line = $pointHolder.find('.part-point-line[data-id="' + id +'"]'),
					$imgDetail = $listPanel.find('.img-detail#p' + partId +'-img-detail'),
					$imgDetailList = $listPanel.find('.list-view-parts#p' + partId +'-img-detail-l');

				setPointEvents($point, $text, $line, $imgDetail, $imgDetailList);

				var imageWidth = $mainImage[0].naturalWidth;
				var pixelsLeft = $point[0].style.left.replace('%', '') * imageWidth / 100;
				var pixelsRight = imageWidth - pixelsLeft;
				var spacing = 20;

				if ($point.attr("data-text-position") === 'text-left') {
					$line.css("width", pixelsLeft - spacing + "px")
					$line.css("left", spacing + "px");
				} else {
					$line.css("width",pixelsRight - spacing - $point.outerWidth() + "px")
					$line.css("right", spacing + "px");
				}
			});

			$subPartPointHolder.find('.part-point').each(function () {
				var $point = $(this),
					id = $(this).attr('data-id'),
					partId = $(this).attr('data-part-id'),
					$text = $(this).parents('.sub-part-points').find('.part-point-text[data-id="' + id +'"]'),
					$line = $(this).parents('.sub-part-points').find('.part-point-line[data-id="' + id +'"]'),
					$imgDetail = $listPanel.find('.img-detail#p' + partId +'-img-detail'),
					$imgDetailList = $listPanel.find('.list-view-parts#p' + partId +'-img-detail-l');

				setPointEvents($point, $text, $line, $imgDetail, $imgDetailList);

				var $subPartImage = $listPanel.find('.img-detail#p' + $point.attr("data-main-part-id") +'-img-detail');

				var $image = $subPartPointHolder.find(".sub-part-points-images img[data-level-counter='" +getPreviousLevelCounter($point.attr("data-level-counter")) +"']");

				// var imageWidth = $image[0] ? $image[0].naturalWidth : $subPartImage[0].naturalWidth;

				function setLinePosition(imageWidth) {
					var pixelsLeft = $point[0].style.left.replace('%', '') * imageWidth / 100;
					var pixelsRight = imageWidth - pixelsLeft;
					var spacing = 20;

					if ($point.attr("data-text-position") === 'text-left') {
						$line
							.css("width", pixelsLeft - spacing + "px")
							.css("left", spacing + "px");
					} else {
						$line
							.css("width",pixelsRight - spacing - $point.outerWidth() + "px")
							.css("right", spacing + "px");
					}
				}

				if ($image[0]) {
					setLinePosition($image[0].naturalWidth);
				} else {
					$subPartImage.on("image-shown", function () {
						setLinePosition(this.width);
					});
				}

			});

			function setPointEvents($point, $text, $line, $imgDetail, $imgDetailList) {
				var $isPartPoint = $point.hasClass("is-part-point");
				var $isSubPartPoint = $point.hasClass("is-sub-part-point");
				var partId = $point.attr("data-part-id");
				var pointLevelCounter = $point.attr("data-level-counter");

				$point
					.on("mouseenter", function () {
						$point.addClass("show");
						$text.addClass("show");
						$line.addClass("show");
					})
					.on("mouseleave", function () {
						$point.removeClass("show");
						$text.removeClass("show");
						$line.removeClass("show");
					});

				$point.on("click", function () {
					// If main part point is clicked
					$subPartImagesHolder.show();

					if ($isPartPoint) {
						activePartId = partId;
						activeSubPartId = undefined;
						$mainPanel.hide();
						$closeDetailProduct.show();
						$tabsButtonsListItems.show();
						if (activeTab == 1) {
							getSubPartPointsHolder(activePartId).show();
						}

						if (activeTab == 1) {
							$imgDetail.show();
							$imgDetail.trigger('image-shown');
						} else {
							$imgDetailList.show();
						}

						if ($imgDetail) {
							$subPartImagesHolder
								.css("width", $imgDetail[0].width)
								.css("height", $imgDetail[0].height);
						}
					}

					// If sub part point is clicked and has an associated image.
					if($isSubPartPoint && findSubPartPointImage(activePartId, pointLevelCounter).length > 0) {
						$listPanel.find(".img-detail").hide();
						activeSubPartId = partId;
						showLevel(pointLevelCounter);
					}
				});
			}

			$closeDetailProduct.on('click', function () {
				if ($tabLink2.hasClass('active')) {
					showImageViewTab();
					return;
				}

				if (activeSubPartId) {
					$tabsButtonsListItems.show();

					showLevel(getPreviousLevelCounter(currentLevelCounter));

					return;
				}

				$mainPanel.show();
				$closeDetailProduct.hide();
				$tabsButtonsListItems.hide();
				$listPanel.find(".img-detail").hide();
				$listPanel.find('ul.list-view-parts').hide();
				$subPartPointHolder.find(".sub-part-points").hide();
				activePartId = undefined;
				$subPartImagesHolder.hide();
			})

			function showLevel(levelCounter) {
				if (! levelCounter) {
					levelCounter = activePartId;
				}

				currentLevelCounter = levelCounter;

				hideAllSubPartPointHolders();

				var $subPartPointsHolder = getSubPartPointsHolder(activePartId, currentLevelCounter);
				$subPartPointsHolder.show();

				$subPartPointHolder.find(".sub-part-points-images img").hide();
				// This is returning back to the Second step
				if (parseInt(currentLevelCounter) == currentLevelCounter) {
					activeSubPartId = undefined;
					$listPanel.find('.img-detail#p' + activePartId +'-img-detail').show();
				} else {
					var $subPartPointImagesHolder = getSubPartPointsImagesHolder(activePartId, getPreviousLevelCounter(currentLevelCounter));
					$subPartPointImagesHolder.show();

					findSubPartPointImage(activePartId, currentLevelCounter).show();
				}
			}

			function findSubPartPointImage(partId, levelCounter) {
				return getSubPartPointsImagesHolder(
					partId,
					getPreviousLevelCounter(levelCounter)
				).find(
					'img[data-level-counter="' + levelCounter + '"]'
				);
			}
			function getSubPartPointsHolder(partId, levelCounter)
			{
				var query = ".sub-part-points.sub-part-points-" + partId;
				query += "[data-level-counter='" + (levelCounter ? levelCounter : partId) + "']";
				return $subPartPointHolder.find(query);
			}

			function hideAllSubPartPointHolders()
			{
				return $subPartPointHolder.find(".sub-part-points").hide();
			}

			function getSubPartPointsImagesHolder(partId, levelCounter)
			{
				var query = ".sub-part-points.sub-part-points-images-" + partId;
				query += "[data-level-counter='" + (levelCounter ? levelCounter : partId) + "']";
				return $subPartPointHolder.find(query);
			}

			function getPreviousLevelCounter(levelCounter) {
				var arr = levelCounter.split("-");
				return arr.splice(0, arr.length - 1).join("-");
			}
		}
	}
})(jQuery, app, _);
